import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import Seo from '@/components/feature/Seo';

export default function NotFound() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <Seo
        title="页面不存在 - 看料社"
        description="你访问的页面不存在或已被移动。可以返回首页或前往追踪列表，继续查看正在跟进的娱乐热点线索。"
      />
      <Container>
        <div className="flex flex-col items-center justify-center text-center">
          <p className="font-heading text-6xl font-bold text-primary-600 md:text-8xl">404</p>
          <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这条线索走丢了</h1>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-base">
            你访问的页面不存在，或者链接已经变更。回到首页看看正在追踪的热点，或者直接进入追踪列表按分类浏览。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/tracking"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              <i className="ri-list-check-2"></i>
              全部追踪
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
}